import { createMuiTheme } from '@material-ui/core/styles';
//import createPalette from '@material-ui/core/styles/palette';

import blue from '@material-ui/core/colors/blue';

export const theme = createMuiTheme({
	overrides: {
		MuiTableRow : {
			root : {
				height : 48
			},
		},
		MuiTableCell: {
			root : { // Name of the rule
				fontSize : '.8125rem',
				lineHeight : 'inherit',
				letterSpacing : 0,
			},
			sizeSmall : {
				padding : `5px 12px`,
			},
			head : {
				lineHeight : 'inherit',
			}
		},
		MuiAppBar : {
			positionStatic : {
				boxShadow :
					`0px 1px 3px -1px rgba(0,0,0,0.08),` +
					`0px 2px 3px 0px rgba(0,0,0,0.12), ` +
					`0px 1px 3px 0px rgba(0,0,0,0.1);`
			}
		}
	},
	typography: {
		useNextVariants: true,
	},
	palette: {
		primary: blue,
	}
});

export const darkTheme = createMuiTheme({
	overrides: {
		TableCell: {
			root : { // Name of the rule
				fontSize : '.8125rem',
				lineHeight : 1,
			},
		},
	},
	typography: {
		useNextVariants: true,
	},
	palette: {
		type: 'dark',
		primary: blue,
	},
});


export const getSharedStyles = (theme) => {
	return {
		table : {
			width : '100%',
			tableLayout: 'auto',
			backgroundColor : 'white',
		},
		paper : {
			width: '100%',
			//overflowX : 'auto',
			//minHeight : 500,
			//marginBottom: 20,
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('sm')]: {
				padding : '20px 20px 20px 20px',
			},
		},
		fetching : {
			fontStyle : 'italic',
			padding : '10px 0px',
			color : '#777',
		}
	};
};
